import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
} from "@mui/material";
import PriceModal from "./PriceModal";
import { IoMdAdd } from "react-icons/io";
import { IoMdTrash } from "react-icons/io";
import { Chip } from "@mui/material";
import { FaEdit } from "react-icons/fa";
import PhotoUploader from "./PhotoUploader";
import BarcodeModal from "./BarcodeModal";
import { validateProduct } from "../../utils/validation";
const ProductVariant = ({
  onVariantsChange,
  initialProductDetails,
  initialPrices,
  setFormErrors,
  productDetails,
  barcode,
  piyasaFiyati,
  satisFiyati,
  description,
}) => {
  const [variantName, setVariantName] = useState("");
  const [variants, setVariants] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [priceModalOpen, setPriceModalOpen] = useState(false);
  const [barcodeModalOpen, setBarcodeModalOpen] = useState(false);
  const [generalPrices, setGeneralPrices] = useState(initialPrices);
  useEffect(() => {
    if (initialPrices) {
      setGeneralPrices(initialPrices);
    }
  }, [initialPrices]);

  const addVariantName = () => {
    const errors = validateProduct(
      productDetails,
      barcode,
      piyasaFiyati,
      satisFiyati,
      description
    );
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    if (variantName.trim()) {
      setVariants([...variants, { name: variantName, options: [] }]);
      setVariantName("");
    }
  };

  const deleteVariant = (variantIndex) => {
    const updatedVariants = variants.filter(
      (_, index) => index !== variantIndex
    );
    setVariants(updatedVariants);
  };

  const addOption = (variantIndex, option) => {
    if (option.trim()) {
      const updatedVariants = [...variants];
      if (!updatedVariants[variantIndex].options.includes(option)) {
        updatedVariants[variantIndex].options.push(option);
        setVariants(updatedVariants);
      }
    }
  };

  const deleteOption = (variantIndex, optionIndex) => {
    const updatedVariants = [...variants];
    updatedVariants[variantIndex].options.splice(optionIndex, 1);
    setVariants(updatedVariants);
  };

  const generateCombinations = (arrays) => {
    if (arrays.length === 0) return [[]];
    const [first, ...rest] = arrays;
    const combinations = generateCombinations(rest);
    return first.flatMap((value) =>
      combinations.map((combination) => [value, ...combination])
    );
  };

  useEffect(() => {
    const optionsArrays = variants.map((variant) => variant.options);
    const allCombinations = generateCombinations(optionsArrays);

    const newRows = allCombinations.map((combination, index) => {
      const existingRow = rows[index] || {};
      console.log("existingRow.photos", existingRow.photos);
      return {
        combination,
        modelCode:
          existingRow.modelCode || initialProductDetails.modelCode || "",
        barcode: existingRow.barcode || initialProductDetails.barcode || "",
        supplierBarcode:
          existingRow.supplierBarcode ||
          initialProductDetails.supplierBarcode ||
          "",
        stock: (existingRow.stock ?? initialProductDetails.stock) || 0,
        prices: existingRow.prices || { ...generalPrices },
        photos: existingRow.photos || [],
      };
    });

    setRows(newRows);
    onVariantsChange(newRows, variants);
  }, [variants, generalPrices]);

  const openPriceModal = (index) => {
    setSelectedRowIndex(index);
    setPriceModalOpen(true);
  };
  const openBarcodeModal = (index) => {
    setSelectedRowIndex(index);
    setBarcodeModalOpen(true);
  };
  const handlePriceChange = (updatedPrices) => {
    const updatedRows = [...rows];
    const marketplaces = Object.keys(updatedPrices);
    marketplaces.forEach((marketplace) => {
      updatedRows[selectedRowIndex].prices[marketplace] = {
        ...updatedRows[selectedRowIndex].prices[marketplace],
        "Satış Fiyatı": updatedPrices[marketplace]["Satış Fiyatı"],
        "Piyasa(Liste Fiyatı)":
          updatedPrices[marketplace]["Piyasa(Liste Fiyatı)"] || "",
        Barcode: updatedPrices[marketplace]["Barcode"],
      };
    });

    setRows(updatedRows);
    setPriceModalOpen(false);
  };
  const handleBarcodeChange = (updatedBarcode) => {
    const updatedRows = [...rows];
    const marketplaces = Object.keys(updatedBarcode);
    marketplaces.forEach((marketplace) => {
      updatedRows[selectedRowIndex].prices[marketplace] = {
        ...updatedRows[selectedRowIndex].prices[marketplace],
        "Satış Fiyatı": updatedBarcode[marketplace]["Satış Fiyatı"],
        "Piyasa(Liste Fiyatı)":
          updatedBarcode[marketplace]["Piyasa(Liste Fiyatı)"] || "",
        Barcode: updatedBarcode[marketplace]["Barcode"],
      };
    });

    setRows(updatedRows);

    setPriceModalOpen(false);
  };
  const handlePhotosChange = (index, updatedPhotos) => {
    const updatedRows = [...rows];
    updatedRows[index].photos = updatedPhotos;
    setRows(updatedRows);
    onVariantsChange(updatedRows, variants);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };
  const inputRef = React.createRef();
  return (
    <>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "500",
          color: "#333",
          textAlign: "left",
          letterSpacing: "0.03em",
          mb: 1,
        }}
      >
        Varyant Oluştur
      </Typography>
      <Grid container spacing={{ xs: 1, sm: 2 }}>
        <Grid item xs={12} sm={10}>
          <TextField
            value={variantName}
            onChange={(e) => setVariantName(e.target.value)}
            onKeyDown={handleKeyDown}
            label="Varyant Adı"
            variant="outlined"
            fullWidth
            size="small"
            sx={{ flex: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            onClick={addVariantName}
            startIcon={<IoMdAdd />}
            variant="outlined"
            sx={{
              color: "#343089",
              borderColor: "#343089",
              textTransform: "none",
              borderRadius: "5px",
              width: "100%",
              height: { xs: "40px", sm: "auto" },
              "&:hover": { backgroundColor: "#f1f1f1" },
            }}
          >
            Ekle
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 1, sm: 2 }}>
        {variants.map((variant, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                mt: 2,
                p: { xs: 1, sm: 2 },
                border: "1px solid #ddd",
                borderRadius: 2,
                backgroundColor: "#fff",
                minHeight: { xs: "auto", sm: "200px" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Header Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: 1, sm: 0 },
                }}
              >
                <Typography sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
                  {variant.name}
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<IoMdTrash />}
                  sx={{
                    color: "#343089",
                    borderColor: "#343089",
                    textTransform: "none",
                    borderRadius: "5px",
                    width: { xs: "100%", sm: "auto" },
                    "&:hover": { backgroundColor: "#f1f1f1" },
                  }}
                  onClick={() => deleteVariant(index)}
                >
                  Sil
                </Button>
              </Box>

              {/* Text Input */}
              <TextField
                inputRef={inputRef}
                placeholder="Seçenek Ekle"
                fullWidth
                size="small"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addOption(index, e.target.value);
                    e.target.value = "";
                  }
                }}
              />

              {/* Options Chips */}
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  minHeight: { xs: "auto", sm: "50px" },
                }}
              >
                {variant.options.map((option, optionIndex) => (
                  <Chip
                    key={optionIndex}
                    label={option}
                    onDelete={() => deleteOption(index, optionIndex)}
                    sx={{
                      color: "#fff",
                      backgroundColor: "#343089",
                      borderRadius: "24px",
                      fontSize: { xs: "0.8rem", sm: "0.875rem" },
                      "&:hover": { backgroundColor: "#29275d" },
                      "& .MuiChip-deleteIcon": { color: "#fff" },
                    }}
                  />
                ))}
              </Box>

              {/* Add Button Container */}
              <Box
                sx={{
                  mt: "auto",
                  pt: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    color: "#343089",
                    borderColor: "#343089",
                    textTransform: "none",
                    borderRadius: "5px",
                    width: { xs: "100%", sm: "auto" },
                    "&:hover": { backgroundColor: "#f1f1f1" },
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    const value = inputRef.current?.value;
                    if (value) {
                      addOption(index, value);
                      inputRef.current.value = "";
                    }
                  }}
                >
                  Ekle
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      {variants.length > 0 && rows.length > 0 && (
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "500",
              color: "#333",
              textAlign: "left",
              letterSpacing: "0.03em",
              mb: 1,
              mt: 4,
            }}
          >
            Yeni Ürün Varyantları
          </Typography>

          <Box
            sx={{
              width: "100%",
              overflowX: "auto",
              mt: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
            }}
          >
            <TableContainer sx={{ maxHeight: { xs: "300px", sm: "400px" } }}>
              <Table size="small" sx={{ minWidth: { xs: 650, sm: 800 } }}>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "white",
                      "& th": {
                        fontWeight: "bold",
                        color: "#333",
                        borderBottom: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      },
                    }}
                  >
                    {variants.map((variant, index) => (
                      <TableCell key={index}>{variant.name}</TableCell>
                    ))}
                    <TableCell>Model Kodu</TableCell>
                    <TableCell>Barkod</TableCell>
                    <TableCell>Tedarikçi Barkod</TableCell>
                    <TableCell>Stok</TableCell>
                    <TableCell>Fiyat</TableCell>
                    <TableCell>Fotoğraflar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" },
                        "&:nth-of-type(even)": { backgroundColor: "#fff" },
                        "& td": {
                          borderBottom: "1px solid #ddd",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {row.combination.map((option, idx) => (
                        <TableCell key={idx}>{option}</TableCell>
                      ))}
                      <TableCell>
                        <TextField
                          value={row.modelCode}
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[index].modelCode = e.target.value;
                            setRows(updatedRows);
                          }}
                          size="small"
                          sx={{ width: { xs: "80px", sm: "100px" } }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          startIcon={<FaEdit />}
                          sx={{
                            color: "#343089",
                            borderColor: "#343089",
                            textTransform: "none",
                            borderRadius: "5px",
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            padding: { xs: "4px 8px", sm: "6px 16px" },
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                          onClick={() => openBarcodeModal(index)}
                        >
                          Düzenle
                        </Button>
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={row.supplierBarcode}
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[index].supplierBarcode = e.target.value;
                            setRows(updatedRows);
                          }}
                          size="small"
                          sx={{ width: { xs: "80px", sm: "100px" } }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={row.stock}
                          type="number"
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[index].stock = e.target.value;
                            setRows(updatedRows);
                          }}
                          size="small"
                          sx={{ width: { xs: "60px", sm: "80px" } }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          startIcon={<FaEdit />}
                          sx={{
                            color: "#343089",
                            borderColor: "#343089",
                            textTransform: "none",
                            borderRadius: "5px",
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            padding: { xs: "4px 8px", sm: "6px 16px" },
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                          onClick={() => openPriceModal(index)}
                        >
                          Düzenle
                        </Button>
                      </TableCell>
                      <TableCell>
                        <PhotoUploader
                          onPhotosChange={(updatedPhotos) =>
                            handlePhotosChange(index, updatedPhotos)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
      {priceModalOpen && (
        <PriceModal
          open={priceModalOpen}
          onClose={() => setPriceModalOpen(false)}
          initialPrices={rows[selectedRowIndex]?.prices || generalPrices}
          onSave={handlePriceChange}
        />
      )}
      {barcodeModalOpen && (
        <BarcodeModal
          open={barcodeModalOpen}
          onClose={() => setBarcodeModalOpen(false)}
          initialBarcodes={rows[selectedRowIndex]?.prices || generalPrices}
          onSave={handleBarcodeChange}
        />
      )}
    </>
  );
};

export default ProductVariant;
